export enum ErrCodes {
  loginExpired = 10000,
  paramsInvalid,
  internalError,
  dataNotExist,
  noPermission,
  tokenInvalid = 10012,
  teamDataInvalid = 10019,
}
